var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7254 22.3996L17.4326 16.1067C18.8405 14.4038 19.6875 12.2208 19.6875 9.84375C19.6875 4.41591 15.2716 0 9.84375 0C4.41591 0 0 4.41591 0 9.84375C0 15.2716 4.41591 19.6875 9.84375 19.6875C12.2208 19.6875 14.4037 18.8405 16.1068 17.4326L22.3996 23.7254C22.7657 24.0915 23.3593 24.0916 23.7254 23.7254C24.0915 23.3593 24.0915 22.7657 23.7254 22.3996ZM1.875 9.84375C1.875 5.44978 5.44978 1.875 9.84375 1.875C14.2377 1.875 17.8125 5.44978 17.8125 9.84375C17.8125 14.2377 14.2377 17.8125 9.84375 17.8125C5.44978 17.8125 1.875 14.2377 1.875 9.84375Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5,
    y1: 19,
    x2: 22,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.de67249a348a87c60df545f48e5d4551.svg";
export { ForwardRef as ReactComponent };